import { updateServiceCategory } from "api/projects";
import Button from "components/Button";
import Form from "components/Form";
import Modal from "components/Modal";
import useAsync from "hooks/use-async";
import React, { FC } from "react";
import { ServiceCategory } from "types/models";
import { required } from "utils/form";

import styles from "./styles.module.scss";

interface Props {
  visible: boolean;
  handleClose(): void;
  onModalClosed(): void;
  serviceCategory: ServiceCategory;
  onSuccess(): void;
}

interface FormValues {
  name: string;
}

const EditServiceCategory: FC<Props> = ({
  visible,
  handleClose,
  onModalClosed,
  serviceCategory,
  onSuccess,
}) => {
  const [submit, submitting] = useAsync((formValues: FormValues) => {
    return updateServiceCategory(serviceCategory.id, formValues).then(() => {
      onSuccess();
      handleClose();
    });
  });

  return (
    <Modal
      onModalClosed={onModalClosed}
      handleClose={handleClose}
      visible={visible}
      title={`Editing: ${serviceCategory.name}`}
    >
      <Form
        className={styles.form}
        initialValues={{ name: serviceCategory.name }}
        onSubmit={submit}
        fields={[
          {
            type: "text",
            title: "Name",
            id: "name",
            validate: [required("Name is required for creation")],
          },
        ]}
      >
        {({ handleSubmit, invalid, hasChanged }) => (
          <Button
            className={styles.submit}
            disabled={!hasChanged || invalid}
            loading={submitting}
            onClick={handleSubmit}
          >
            Edit
          </Button>
        )}
      </Form>
    </Modal>
  );
};

export default EditServiceCategory;
